import { AESUtils, tryParseToObject } from '@bty/util'
import { request } from '../../client'
import type { STSTokenResponse } from './type'

const version = 'v1'

export async function getSTSToken() {
  const env = process.env.NODE_ENV
  const encryptedData = await request.get<string>(`${version}/upload_sts`)
  const decryptedData = new AESUtils(env).decryptAES_CBC(encryptedData)
  return tryParseToObject(decryptedData) as STSTokenResponse
}

export async function getOssSignatureUrl(
  key: string,
  params?: Record<string, any>,
) {
  const data = await request.post<string>(`${version}/oss/sign_url`, {
    params,
    key,
  })
  return data
}

export async function checkOssSignatureUrlIsExist(url: string) {
  return await request.post<boolean>(`${version}/oss/url_exist`, {
    key: url,
  })
}
